export const configs = {
  publicId: process.env["REACT_APP_PUBLIC_ID"] ?? "public_Id",
  templateId: process.env["REACT_APP_TEMPLATE_ID"] ?? "template_id",
  serviceId: process.env["REACT_APP_SERVICE_ID"] ?? "service_id",
};
